import { useState, useRef, useEffect } from 'react';
import { MoreVert } from '@mui/icons-material';

import {
  EllipsisMenuContainer,
  EllipsisButton,
  EllipsisDropdown,
  EllipsisMenuContent,
} from './EllipsisMenu.styles.js';

/**
 * Reusable ellipsis (⋮) menu: button toggles a dropdown that closes on outside click.
 * @param {React.ReactNode} children - Content for the dropdown (e.g. <ul><li>...</li></ul>)
 * @param {string} [ariaLabel] - Aria label for the trigger button (default "More options")
 * @param {string} [className] - Optional class for the container
 */
export default function EllipsisMenu({ children, ariaLabel = 'More options', className }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <EllipsisMenuContainer ref={containerRef} className={className} $isOpen={open}>
      <EllipsisButton
        type="button"
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <MoreVert style={{ color: '#FFFFFF', fontSize: '20px' }} />
      </EllipsisButton>
      {open && (
        <EllipsisDropdown>
          <EllipsisMenuContent>{children}</EllipsisMenuContent>
        </EllipsisDropdown>
      )}
    </EllipsisMenuContainer>
  );
}
